import { ReactElement } from "react";
import { getIconTemplateData } from "../Activity/Activity";
import { ActivityCard } from "../Activity/Card/ActivityCard";
import { ActivityContent } from "../Activity/Content/ActivityContent";
import { AvailableNotificationViewModel } from "client/Api/Notifications/notifications";
import styles from "../ActivityFeedSpaces.module.less";
import { parseDtoDate } from "client/DateAndTime/dateTimeUtils";
import { useUserTimezone } from "client/Hooks";
import { TimeZone } from "client/DateAndTime/timezones";


export type BehindActivityProps = {
	categoryName: string;
	activity: AvailableNotificationViewModel;
	onActivityChanged: () => void;
};

const {
	Description,
	Footer
} = ActivityCard;

const {
	TimeIndication
} = Footer;

export const BehindActivity = (props: BehindActivityProps): ReactElement => {
	const {
		categoryName,
		activity,
		onActivityChanged
	} = props;

	const userTimezone: TimeZone = useUserTimezone();

	const {
		availableFrom,
		color
	} = activity;

	return (
		<div className={styles.activityItem}>
			<ActivityCard
				hasFooter
				categoryName={categoryName}
				icon={getIconTemplateData(activity, true)}
				color={color}
				isDismissed={activity.isDismissed}
				isNotInteractable
			>
				<Description>
					<ActivityContent
						activity={activity}
						onActivityChanged={onActivityChanged}
					/>
				</Description>
				<Footer>
					<TimeIndication timestamp={parseDtoDate(availableFrom)} timezone={userTimezone} />
				</Footer>
			</ActivityCard>
		</div>
	);
};

BehindActivity.displayName = "BehindActivity";